<template>
  <div :class="'mold' + (me._2fa !== 'TOTP' || isExpired.expired ? ' active' : '')">
    <v-btn v-if="isExpired.expired" icon small color="yellow" @click="handleOpenUserProfile">
      <v-icon>mdi-lock-clock</v-icon>
    </v-btn>
    <v-btn v-if="me._2fa !== 'TOTP'" icon small color="red" @click="handleOpen2FA">
      <v-icon>mdi-shield-key</v-icon>
    </v-btn>
    <v-menu origin="center center" transition="scale-transition" :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <v-list-item-avatar class="ma-0 ml-2" v-bind="attrs" v-on="on">
          <img
            v-if="me.profile_photo && me.profile_photo.url"
            :src="me.profile_photo.url"
            :alt="me.name"
            :loading="me" />
          <img :loading="me" v-else src="@/assets/images/no-photo.jpg" :alt="me.name" />
        </v-list-item-avatar>
      </template>
      <v-card dark :min-width="smallScreen ? '' : '400'">
        <v-list class="pa-0" v-if="me">
          <v-list-item @click="handleOpenUserProfile">
            <v-list-item-avatar>
              <img
                v-if="me.profile_photo && me.profile_photo.url"
                :src="me.profile_photo.url"
                :alt="me.name"
                :loading="me" />
              <img :loading="me" v-else src="@/assets/images/no-photo.jpg" :alt="me.name" />
            </v-list-item-avatar>

            <v-list-item-content class="text-center">
              <v-list-item-title>{{ me.name || "Nome do usuário" }}</v-list-item-title>
              <v-list-item-subtitle>{{ me.email || "Email do usuário" }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <!-- 2fa -->
        <v-divider v-show="me._2fa !== 'TOTP'"></v-divider>
        <v-list class="pa-0" color="red" v-show="me._2fa !== 'TOTP'">
          <v-list-item @click="handleOpen2FA" link>
            <v-icon class="mr-3">mdi-shield-key</v-icon>
            <span>Ativar <b>2FA</b></span>
          </v-list-item>
        </v-list>

        <!-- Senha -->
        <v-divider v-show="isExpired.expired"></v-divider>
        <v-list class="pa-0" color="yellow" v-show="isExpired.expired">
          <v-list-item @click="handleOpenUserProfile" link>
            <v-icon class="mr-3">mdi-lock-clock</v-icon>
            <span>Redefina a <b>senha</b></span>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list class="pa-0">
          <v-list-item @click="handleLogout()" link>
            <v-icon class="mr-3">mdi-power</v-icon>
            <span>Sair</span>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    me: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isExpired: {
        expired: false,
      },
    };
  },
  computed: {
    smallScreen(): boolean {
      return ["xs", "sm"].includes(this.$vuetify.breakpoint.name);
    },
  },
  methods: {
    handleOpenUserProfile() {
      this.$emit("userProfile");
    },
    handleOpen2FA() {
      this.$emit("2fa");
    },
    handleLogout() {
      this.$emit("logout");
    },
  },
});
</script>
